module.exports = __webpack_public_path__ + "img/choice.f9e3322a.png";